import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import Box from '@mui/material/Box';

const DropzoneWithPreview = ({ type, handleFileUpload, initialImage, disabled }) => {
  const [preview, setPreview] = useState(initialImage || null);

  const onDrop = (acceptedFiles) => {
    if (disabled || !acceptedFiles || acceptedFiles.length === 0) return;
    const file = acceptedFiles[0];
    const previewUrl = URL.createObjectURL(file);
    setPreview(previewUrl);
    handleFileUpload(type, acceptedFiles);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    // accept: 'image/jpeg, image/png',
    accept: {
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png']
    },
    onDrop,
    disabled,
  });


  // decide container dimensions per type
  const containerSize =
    type === 'logo'
      ? { width: '350px', height: '150px' }
      : type === 'image'
      ? { width: '150px', height: '150px' }  // profile
      : { width: '150px', height: '150px' }; // banner

  // decide image styling per type
  const imgStyle =
    type === 'image'
      ? { width: '100%', height: '100%', objectFit: 'cover' }
      : { width: '100%', height: 'auto', objectFit: 'contain' };

  return (
    <Box
      {...getRootProps()}
      sx={{
        position: 'relative',
        border: '3px dashed black',
        backgroundColor:' #CBCBCB',
        borderRadius: '4px',
        overflow: 'hidden',
        mb: disabled ? 0 : 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...containerSize,
      }}
    >
      <input {...getInputProps()} />
      {preview ? (
        <img
          src={
            preview.startsWith('blob')
              ? preview
              : `${process.env.REACT_APP_API_ROUTE}/files/${preview}`
          }
          style={imgStyle}
        />
      ) : (
        <Box sx={{ textAlign: 'center', p: 2 }}>
          {isDragActive ? (
            disabled ? (
              <p>
                No{' '}
                {type === 'logo'
                  ? 'Logo'
                  : type === 'image'
                  ? 'Profile'
                  : 'Banner'}{' '}
                image uploaded
              </p>
            ) : (
              <p>
                Drop the{' '}
                {type === 'image' ? 'Profile' : 'Banner'} image here…
              </p>
            )
          ) : disabled ? (
            <p>
              No{' '}
              {type === 'image'
                ? 'Profile'
                : type === 'logo'
                ? 'Logo'
                : 'Banner'}{' '}
              image uploaded
            </p>
          ) : (
            <p>
              Drag &amp; drop{' '}
              {type === 'logo'
                ? 'Logo'
                : type === 'image'
                ? 'Profile'
                : 'Banner'}{' '}
              image here,
              <br />
              or click to select file
            </p>
          )}
        </Box>
      )}
    </Box>
  );
};

export default DropzoneWithPreview;
